import { Controller } from "@hotwired/stimulus";

// Manages the dynamic label+value rows for property details.
// Clones from a <template> tag to avoid hardcoding field names in JS.

export default class extends Controller {
  static targets = ["list", "rowTemplate"];

  static MAX_ROWS = 10;

  addRow() {
    if (this.listTarget.children.length >= this.constructor.MAX_ROWS) return;

    const clone = this.rowTemplateTarget.content.cloneNode(true);
    this.listTarget.appendChild(clone);

    // Focus the label input of the newly added row
    const lastRow = this.listTarget.lastElementChild;
    lastRow?.querySelector("input")?.focus();
  }

  removeRow(event) {
    event.currentTarget.closest(".detail-row")?.remove();
  }
}
